import { render, staticRenderFns } from "./ImageGroupPreview.vue?vue&type=template&id=022dd9ed&scoped=true&"
import script from "./ImageGroupPreview.vue?vue&type=script&lang=js&"
export * from "./ImageGroupPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageGroupPreview.vue?vue&type=style&index=0&id=022dd9ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022dd9ed",
  null
  
)

export default component.exports